import {
    actionTypes,
} from './freeBets.actions'

const initialState = {
    list: [],
    selectedFreeBet: null,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_FREE_BETS:
            return {
                ...state,
                list: action.list,
            }
        case actionTypes.CLEAR_FREE_BETS:
            return {
                ...state,
                list: [],
            }
        case actionTypes.SELECT_FREE_BET:
            return {
                ...state,
                selectedFreeBet: action.freeBetId,
            }
        case actionTypes.CLEAR_FREE_BET:
            return {
                ...state,
                selectedFreeBet: null,
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /src/js/common/freeBets/freeBets.reducer.js